module.exports = __webpack_public_path__ + "static/img/bg_3.23026f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/bg_3.jpg
// module id = 6BNe
// module chunks = 0